module.exports = __webpack_public_path__ + "img/game5.1.85be63eb.png";